<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Individual Type</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="individualActivity"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-input name="name" label="Activity Name" />
              </v-col>
              <v-col cols="12">
                <custom-input name="risk_score" label="Risk score" />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    individualActivity: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      types: [],
      key: 1,
    };
  },
  computed: {
    url() {
      if (this.individualActivity && this.individualActivity.id) {
        return `api/v1/individual-activities/${this.individualActivity.id}`;
      }
      return "api/v1/individual-activities";
    },
  },
  watch: {},
  methods: {},
};
</script>
